var render = function render(){var _vm=this,_c=_vm._self._c;return _c('questionnaire-table',{on:{"change":_vm.dataChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }